import { connect } from 'react-redux';
// import Report from '../../components/digital_rating/Report';
import UniversityList from '../../components/dashboard/main/university/UniversityList';

const mapStateToProps = () => ({
});

const mapDispatchToProps = () => ({
});

export default connect(mapStateToProps, mapDispatchToProps)(UniversityList);
